import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltPresenceTooltipAvatarWireframe from './VeltPresenceTooltipAvatarWireframe/VeltPresenceTooltipAvatarWireframe';
import VeltPresenceTooltipUserActiveWireframe from './VeltPresenceTooltipUserActiveWireframe/VeltPresenceTooltipUserActiveWireframe';
import VeltPresenceTooltipUserInactiveWireframe from './VeltPresenceTooltipUserInactiveWireframe/VeltPresenceTooltipUserInactiveWireframe';
import VeltPresenceTooltipUserNameWireframe from './VeltPresenceTooltipUserNameWireframe/VeltPresenceTooltipUserNameWireframe';
import VeltPresenceTooltipStatusContainerWireframe from './VeltPresenceTooltipStatusContainerWireframe/VeltPresenceTooltipStatusContainerWireframe';
var VeltPresenceTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-presence-tooltip-wireframe", __assign({}, transformedProps), children));
};
VeltPresenceTooltipWireframe.Avatar = VeltPresenceTooltipAvatarWireframe;
VeltPresenceTooltipWireframe.UserActive = VeltPresenceTooltipUserActiveWireframe;
VeltPresenceTooltipWireframe.UserInactive = VeltPresenceTooltipUserInactiveWireframe;
VeltPresenceTooltipWireframe.UserName = VeltPresenceTooltipUserNameWireframe;
VeltPresenceTooltipWireframe.StatusContainer = VeltPresenceTooltipStatusContainerWireframe;
export default VeltPresenceTooltipWireframe;
